/* @flow */
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import Button from 'components/Button.jsx';
import './styles/DeliveryModalFocusedErrorView.scss';

class DeliveryModalFocusedErrorView extends React.Component {
  static propTypes = {
    onClose: React.PropTypes.func.isRequired,
    name: React.PropTypes.string.isRequired,
  };

  getTitle = () => {
    return (
      <span>
        We’re having trouble sending messages
        to {this.props.name}
      </span>
    );
  };

  getSubText = () => {
    return (
      <span>
        {this.props.name} may not have a device or phone number that can
        receive your messages. Please contact {this.props.name} directly.
      </span>
    );
  };

  render() {
    return (
      <Dialog
        eventScreenName="DeliveryModalFocusedErrorView"
        {...this.props}
        title={this.getTitle()}
        subtext={this.getSubText()}
        image={require('assets/images/lighthouse.png')}
        className="DeliveryModalFocusedErrorView-dialog"
        size="medium">
        <div className="DeliveryModalFocusedErrorView-body" >
          <Button onClick={this.props.onClose}>OK, got it!</Button>
        </div>
      </Dialog>
    );
  }
}

export default DeliveryModalFocusedErrorView;



// WEBPACK FOOTER //
// ./src/chat/components/DeliveryModalFocusedErrorView.jsx